export default {
    data() {
        return {
            search: "",
            filterElements: {
                topics: false,
                countries: false,
                scope: false,
                status: false,
            },
            filterData: [],
        };
    },
    created() {
        window.addEventListener("keyup", this.keyUp);
    },
    computed: {
        // pages (reactive) depending on current page
        filterCount() {
            return this.$store.getters.filterCount;
        },
        appliedFilterLabels() {
            return this.$store.getters.appliedFilterLabels;
        },
        appliedFilterIDs() {
            return this.$store.getters.appliedFilterIDs;
        },
        searchQuery() {
            return this.$store.getters.searchQuery;
        },
        filterElData() {
            return this.$store.getters.filterData;
        },
    },
    watch: {
        searchQuery(value) {
            this.search = value;
        },
        filterElData(value) {
            this.filterData = value;
        },
    },
    methods: {
        closeDropdowns(current) {
            Object.keys(this.filterElements).forEach((item) => {
                if (item !== current) {
                    this.filterElements[item] = false;
                }
            });
        },
        keyUp(evt) {
            if (evt) {
                if (evt.keyCode == 27) {
                    this.closeDropdowns();
                }
            } else {
                this.closeDropdowns();
            }
        },
        setFilter(args) {
            if (args) {
                this.current = args.filterID;
                this.$store.dispatch("updateFilters", args);
            }
        },
        resetFilters() {
            const filterBox = document.querySelector(".m-c-list-filter__form");
            const checkBoxes = filterBox.querySelectorAll(
                "input[type=checkbox]"
            );
            checkBoxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            this.$store.dispatch("resetFilters");
            this.$store.dispatch("resetItems");
        },
        filterSearch() {
            if (this.$store.getters.filterCount > 0) {
                this.resetFilters();
            }
            if (this.search.length > 0) {
                this.$store.dispatch("filterBySearchTerm", this.search);
            } else {
                this.$store.dispatch("resetItems");
            }
        },
    },
};
